import { QueryFunctionContext, useQuery, UseQueryResult } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError, GetOneOnOneMeetingDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";
import { GetTeamMeetingDto } from "../../types/meetings/GetTeamMeetingDto";

const useGetMeetingDetailRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getMeetingDetailRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.meetings.getMeetingDetail>>): Promise<
    GetOneOnOneMeetingDto | GetTeamMeetingDto
  > {
    const accessToken = await getAccessToken();
    const [{ meetingGuid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/meetings/${meetingGuid}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getMeetingDetailRequest };
};

const useGetMeetingDetail = (meetingGuid: string, enabled?: boolean) => {
  const { getMeetingDetailRequest } = useGetMeetingDetailRequest();

  return useQuery({
    queryKey: queryKeys.meetings.getMeetingDetail(meetingGuid),
    queryFn: getMeetingDetailRequest,
    enabled: enabled,
  });
};

const useGetOneOnOneMeetingDetail = (meetingGuid: string, enabled?: boolean) => {
  return useGetMeetingDetail(meetingGuid, enabled) as UseQueryResult<GetOneOnOneMeetingDto>;
};

const useGetTeamMeetingDetail = (meetingGuid: string, enabled?: boolean) => {
  return useGetMeetingDetail(meetingGuid, enabled) as UseQueryResult<GetTeamMeetingDto>;
};

export { useGetMeetingDetail, useGetOneOnOneMeetingDetail, useGetTeamMeetingDetail };
